import moment from "moment";

export function simplifyDateToMonth(date) {
    return moment(date).format("YYYY-MM");
}

export function simplifyDate(date) {
    return moment(date).format("YYYY-MM-DD");
}

export function isWeekend(date) {
    return date.getDay() === 0 || date.getDay() === 6;
}

export function weekends(view, date) {
    return view === 'month' && isWeekend(date);
}

export function olderThanXDays(current, pickedDate, x) {
    return new Date().setDate(current.getDate() - x) > pickedDate;
}

export function moreThanXDaysDifference(current, future, x) {
    return new Date().setDate(future.getDate() - x) > current;
}

export function monthToName(month) {
    return moment(new Date(`${month}-01`)).format("MMMM");
}